const Profile2Users = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
      <path
        d="M7.75104 9.10558C7.67187 9.09766 7.57687 9.09766 7.48979 9.10558C5.60562 9.04225 4.10938 7.4985 4.10938 5.5985C4.10937 3.65891 5.67687 2.0835 7.62437 2.0835C9.56396 2.0835 11.1394 3.65891 11.1394 5.5985C11.1315 7.4985 9.63521 9.04225 7.75104 9.10558Z"
        stroke={color}
        strokeWidth="1.09615"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4896 3.6665C15.0255 3.6665 16.2605 4.90942 16.2605 6.43734C16.2605 7.93359 15.073 9.15275 13.5926 9.20817C13.5292 9.20025 13.458 9.20025 13.3867 9.20817"
        stroke={color}
        strokeWidth="1.09615"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.79234 12.027C1.87651 13.3095 1.87651 15.3995 3.79234 16.6741C5.96943 18.1307 9.53984 18.1307 11.7169 16.6741C13.6328 15.3916 13.6328 13.3016 11.7169 12.027C9.54776 10.5782 5.97734 10.5782 3.79234 12.027Z"
        stroke={color}
        strokeWidth="1.09615"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0195 16.3335C15.5895 16.2147 16.1279 15.9852 16.5712 15.6447C17.8062 14.7185 17.8062 13.1906 16.5712 12.2643C16.1358 11.9318 15.6054 11.7102 15.0433 11.5835"
        stroke={color}
        strokeWidth="1.09615"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Profile2Users;
